import React, { useEffect, useState } from "react";
import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    Paper,
    Container,
    Typography,
    CircularProgress,
    Switch,
    FormControlLabel,
    Box,
    TableSortLabel,
} from "@mui/material";

// parse "port,phone,phone"
function parseNumberEntry(str) {
    const parts = String(str).split(",");
    if (parts.length === 3 && parts[1] === parts[2]) {
        return {
            port: parts[0],
            phone: parts[1],
        };
    }
    return { port: "", phone: String(str) };
}

// Load switch states from localStorage
function getInitialSwitchState() {
    const defaultState = { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true };
    try {
        const saved = localStorage.getItem("goipEnabled");
        if (saved) {
            return { ...defaultState, ...JSON.parse(saved) };
        }
    } catch (err) {
        console.error("Failed to parse goipEnabled from localStorage:", err);
    }
    // Default all ON
    return defaultState;
}

export default function GoipNumbersWithStatus() {
    const [data, setData] = useState({});
    const [error, setError] = useState(null);
    const [numberStatus, setNumberStatus] = useState({});
    const [callMetricsBySim, setCallMetricsBySim] = useState({});
    const [smsMetricsBySim, setSmsMetricsBySim] = useState({});
    const [loadStatsBySim, setLoadStatsBySim] = useState({});

    const [goipEnabled, setGoipEnabled] = useState(getInitialSwitchState);
    const [sortConfig, setSortConfig] = useState({
        column: null,
        direction: 'asc',
    });

    const accessToken = "uBEiuHBXrDfiuthssKUQFN4xyJzmWPj3";
    const bulkMetricsUrl = "https://frek.cc/proxy/38.54.86.24:5006/sim-metrics/bulk";
    const bulkLoadCountUrl = "https://frek.cc/proxy/38.54.86.24:7700/sim_load_count_bulk";
    const goip9NumbersUrl = "https://frek.cc/proxy/10.147.19.189:5070/fetch-numbers";

    const normalizeSim = (value) => String(value || "").replace(/\D/g, "");

    const formatDuration = (totalSeconds) => {
        const sec = Math.max(0, Number(totalSeconds) || 0);
        const h = Math.floor(sec / 3600);
        const m = Math.floor((sec % 3600) / 60);
        const s = sec % 60;
        return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
    };

    useEffect(() => {
        localStorage.setItem("goipEnabled", JSON.stringify(goipEnabled));
    }, [goipEnabled]);


      useEffect(() => {
        document.title = 'RegBy ?';
      }, []);

    const getNumberUserFromDb = async (sim) => {
        const endpoint = `https://frek.cc/proxy/38.54.86.24:5000/registeredBy/${sim}`;
        try {
            const response = await fetch(endpoint, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": accessToken,
                },
            });
            if (!response.ok) {
                console.error("Request failed with status:", response.status);
                return "";
            }
            const jsonData = await response.json();
            if (Array.isArray(jsonData) && jsonData.length > 0) {
                return jsonData[0].value;
            }
            return "";
        } catch (error) {
            console.error("Error fetching 'registeredBy':", error);
            return "";
        }
    };


    // Fetch phone data for a particular goipNumber
    const fetchApiData = async (goipNumber) => {
        try {
            if (goipNumber === 9) {
                const response = await fetch(goip9NumbersUrl);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const rawEntries = await response.json();
                const safeEntries = Array.isArray(rawEntries) ? rawEntries : [];
                const parsedAndRegisteredEntries = await Promise.all(
                    safeEntries.map(async (phoneValue, index) => {
                        const phone = String(phoneValue || "").trim();
                        const port = String(index + 1);
                        const registeredBy = phone ? await getNumberUserFromDb(phone) : "";
                        return { port, phone, registeredBy };
                    })
                );

                setData((prevData) => ({
                    ...prevData,
                    goip9: parsedAndRegisteredEntries,
                }));
                return;
            }

            const response = await fetch(
                `https://frek.cc/proxy/38.54.86.24:5090/fetch-api/goip${goipNumber}`
            );
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const textData = await response.text();

            const regex = /^(?!\/\/).*var strLocNumList = '({.*?})';/ms;
            const matches = textData.match(regex);
            if (!matches || !matches[1]) {
                throw new Error("Data not found in the fetched string.");
            }

            let jsonString = matches[1].replace(/\\"/g, '"');
            if (jsonString[0] !== "{" || jsonString[jsonString.length - 1] !== "}") {
                throw new Error("Extracted string is not valid JSON");
            }

            const jsonData = JSON.parse(jsonString);
            const rawEntries = jsonData.data || [];

            // Parse out port & phone, fetch who registered each phone
            const parsedAndRegisteredEntries = await Promise.all(
                rawEntries.map(async (entry) => {
                    const { port, phone } = parseNumberEntry(entry);
                    const registeredBy = await getNumberUserFromDb(phone);
                    return { port, phone, registeredBy };
                })
            );

            setData((prevData) => ({
                ...prevData,
                [`goip${goipNumber}`]: parsedAndRegisteredEntries,
            }));
        } catch (error) {
            console.error("Error fetching or parsing data:", error);
            setError(error);
        }
    };

    // Fetch status data
    useEffect(() => {
        const fetchStatusData = async () => {
            try {
                const response = await fetch("https://frek.cc/proxy/10.147.19.68:5544/get-inserted-numbers");
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const statusData = await response.json();
                setNumberStatus(statusData);
            } catch (error) {
                console.error("Error fetching status data:", error);
                setError(error);
            }
        };
        fetchStatusData();
    }, []);

    // Listen to changes in goipEnabled
    useEffect(() => {
        for (let i = 1; i <= 9; i++) {
            const isOn = goipEnabled[i];
            const goipKey = `goip${i}`;
            const hasData = !!data[goipKey];

            if (isOn && !hasData) {
                fetchApiData(i);
            } else if (!isOn && hasData) {
                setData((prev) => {
                    const copy = { ...prev };
                    delete copy[goipKey];
                    return copy;
                });
            }
        }
    }, [goipEnabled, data]);

    useEffect(() => {
        let isMounted = true;

        const fetchMetricsBulk = async () => {
            try {
                const sims = Array.from(
                    new Set(
                        Object.values(data)
                            .flat()
                            .map((entry) => normalizeSim(entry?.phone))
                            .filter(Boolean)
                    )
                );

                if (sims.length === 0) {
                    setCallMetricsBySim({});
                    setSmsMetricsBySim({});
                    return;
                }

                const response = await fetch(bulkMetricsUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ sims }),
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch bulk SIM metrics");
                }

                const payload = await response.json();
                const items = Array.isArray(payload?.items) ? payload.items : [];
                if (!isMounted) return;

                const nextCallMap = {};
                const nextSmsMap = {};

                items.forEach((item) => {
                    const key = normalizeSim(item?.sim);
                    if (!key) return;
                    if (item?.call) nextCallMap[key] = item.call;
                    if (item?.sms) nextSmsMap[key] = item.sms;
                });

                setCallMetricsBySim(nextCallMap);
                setSmsMetricsBySim(nextSmsMap);
            } catch (metricsError) {
                console.error("Error fetching bulk SIM metrics:", metricsError);
            }
        };

        fetchMetricsBulk();
        return () => {
            isMounted = false;
        };
    }, [data]);

    useEffect(() => {
        let isMounted = true;

        const fetchLoadCountsBulk = async () => {
            try {
                const phones = Object.values(data)
                    .flat()
                    .map((entry) => String(entry?.phone || "").trim())
                    .filter(Boolean);

                if (phones.length === 0) {
                    setLoadStatsBySim({});
                    return;
                }

                const requestNumbers = Array.from(
                    new Set(
                        phones
                            .map((phone) => normalizeSim(phone))
                            .filter(Boolean)
                    )
                );

                const response = await fetch(bulkLoadCountUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ numbers: requestNumbers }),
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch bulk SIM load counts");
                }

                const payload = await response.json();
                const results = Array.isArray(payload?.results) ? payload.results : [];
                if (!isMounted) return;

                const nextMap = {};
                results.forEach((item) => {
                    const raw = String(item?.number || "").trim();
                    const normalized = normalizeSim(raw);
                    const tenDigit = normalized.length >= 10 ? normalized.slice(-10) : normalized;
                    const totalLoads = Number(item?.total_successful_loads || 0);

                    if (raw) nextMap[raw] = totalLoads;
                    if (normalized) nextMap[normalized] = totalLoads;
                    if (tenDigit) nextMap[tenDigit] = totalLoads;
                });

                setLoadStatsBySim(nextMap);
            } catch (loadError) {
                console.error("Error fetching bulk SIM load counts:", loadError);
            }
        };

        fetchLoadCountsBulk();
        return () => {
            isMounted = false;
        };
    }, [data]);

    // Flatten the data for display
    let tableRows = [];
    Object.keys(data).forEach((goipKey) => {
        const goipNum = goipKey.replace("goip", "");
        const entries = data[goipKey] || [];
        entries.forEach((entry) => {
            const status = numberStatus[entry.phone]?.status || "-";
            const normalizedPhone = normalizeSim(entry.phone);
            const callMetric =
                callMetricsBySim[normalizedPhone] ||
                callMetricsBySim[normalizedPhone.slice(-10)] ||
                null;
            const smsMetric =
                smsMetricsBySim[normalizedPhone] ||
                smsMetricsBySim[normalizedPhone.slice(-10)] ||
                null;
            const totalLoads =
                loadStatsBySim[entry.phone] ||
                loadStatsBySim[normalizedPhone] ||
                loadStatsBySim[normalizedPhone.slice(-10)] ||
                0;
            tableRows.push({
                goip: goipNum,
                port: entry.port,
                phone: entry.phone,
                registeredBy: entry.registeredBy,
                status: status,
                dialed: callMetric?.dialed || 0,
                alerted: callMetric?.alerted || 0,
                connected: callMetric?.connected || 0,
                failed: callMetric?.failed || 0,
                durationSec: callMetric?.duration_sec || 0,
                smsSent: smsMetric?.sms_sent || 0,
                smsFailed: smsMetric?.sms_failed || 0,
                smsSegments: smsMetric?.sms_segments || 0,
                totalLoads,
            });
        });
    });

    // Sorting Logic
    const handleRequestSort = (column) => {
        setSortConfig((prev) => {
            if (prev.column === column) {
                return { column, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
            } else {
                return { column, direction: 'asc' };
            }
        });
    };

    if (sortConfig.column) {
        tableRows.sort((a, b) => {
            const aVal = a[sortConfig.column];
            const bVal = b[sortConfig.column];
            if (typeof aVal === "number" && typeof bVal === "number") {
                return sortConfig.direction === "asc" ? aVal - bVal : bVal - aVal;
            }
            const aStr = String(aVal ?? "");
            const bStr = String(bVal ?? "");
            return sortConfig.direction === "asc" ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr);
        });
    }

    const isLoading = tableRows.length === 0 && !error;

    return (
        <Container style={{ margin: "20px" }}>
            <Typography variant="h5" gutterBottom>
                GoIP Numbers Table
            </Typography>

            {error && (
                <Typography variant="body1" color="error" gutterBottom>
                    Error: {error.message}
                </Typography>
            )}

            {/* Switches to toggle each goip on/off */}
            <Box display="flex" flexWrap="wrap" mb={2}>
                {Array.from({ length: 9 }, (_, i) => i + 1).map((goipNumber) => (
                    <FormControlLabel
                        key={goipNumber}
                        control={
                            <Switch
                                checked={goipEnabled[goipNumber]}
                                onChange={() =>
                                    setGoipEnabled((prev) => ({ ...prev, [goipNumber]: !prev[goipNumber] }))
                                }
                            />
                        }
                        label={`GoIP #${goipNumber}`}
                        style={{ marginRight: "20px" }}
                    />
                ))}
            </Box>

            <TableContainer component={Paper} style={{ maxWidth: 1000 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            {/* GOIP column */}
                            <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }} sortDirection={sortConfig.column === 'goip' ? sortConfig.direction : false}>
                                <TableSortLabel
                                    active={sortConfig.column === 'goip'}
                                    direction={sortConfig.direction}
                                    onClick={() => handleRequestSort('goip')}
                                >
                                    GoIP No.
                                </TableSortLabel>
                            </TableCell>

                            {/* PORT column */}
                            <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }} sortDirection={sortConfig.column === 'port' ? sortConfig.direction : false}>
                                <TableSortLabel
                                    active={sortConfig.column === 'port'}
                                    direction={sortConfig.direction}
                                    onClick={() => handleRequestSort('port')}
                                >
                                    Port
                                </TableSortLabel>
                            </TableCell>

                            {/* PHONE column */}
                            <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }} sortDirection={sortConfig.column === 'phone' ? sortConfig.direction : false}>
                                <TableSortLabel
                                    active={sortConfig.column === 'phone'}
                                    direction={sortConfig.direction}
                                    onClick={() => handleRequestSort('phone')}
                                >
                                    Number
                                </TableSortLabel>
                            </TableCell>

                            {/* REGISTERED BY column */}
                            <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}
                                sortDirection={sortConfig.column === 'registeredBy' ? sortConfig.direction : false}
                            >
                                <TableSortLabel
                                    active={sortConfig.column === 'registeredBy'}
                                    direction={sortConfig.direction}
                                    onClick={() => handleRequestSort('registeredBy')}
                                >
                                    Registered By
                                </TableSortLabel>
                            </TableCell>
                            <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}>Status</TableCell>
                            <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}>Dialed</TableCell>
                            <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}>Alerted</TableCell>
                            <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}>Connected</TableCell>
                            <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}>Failed</TableCell>
                            <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}>Talk Time</TableCell>
                            <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}>SMS Sent</TableCell>
                            <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}>SMS Failed</TableCell>
                            <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}>SMS Seg</TableCell>
                            <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}>Load Count</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {isLoading ? (
                            <TableRow>
                                <TableCell colSpan={15} align="center">
                                    <CircularProgress />
                                </TableCell>
                            </TableRow>
                        ) : (
                            tableRows.map((row, idx) => (
                                <TableRow key={idx}
                                    sx={{
                                        "&:last-child td, &:last-child th": {},
                                        cursor: 'pointer',
                                        '&:hover': {
                                            backgroundColor: 'rgba(63, 81, 181, 0.1)',
                                        },
                                    }}>
                                    <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }} >{row.goip}</TableCell>
                                    <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }} >{row.port}</TableCell>
                                    <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }} >{row.phone}</TableCell>
                                    <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }} >{row.registeredBy}</TableCell>
                                    <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }} >{row.status}</TableCell>
                                    <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }} >{row.dialed}</TableCell>
                                    <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }} >{row.alerted}</TableCell>
                                    <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }} >{row.connected}</TableCell>
                                    <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }} >{row.failed}</TableCell>
                                    <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }} >{formatDuration(row.durationSec)}</TableCell>
                                    <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }} >{row.smsSent}</TableCell>
                                    <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }} >{row.smsFailed}</TableCell>
                                    <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }} >{row.smsSegments}</TableCell>
                                    <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }} >{row.totalLoads}</TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Container>
    );
}


